import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { renderTypographyStyles } from 'mui/base/utils';

export const StyledLeadText = styled(Typography)(
  ({ theme }) => `
    color: ${theme.DS_palette.text.secondary};
    margin-top: ${theme.DS_spacing(['xxs'])};
`,
);

export const SharedLinesTextEllipsisStyle = lines => `
  display: -webkit-box;
  -webkit-line-clamp: ${lines};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;  
`;

export const RichMarkdownDS = ({ theme }) => `
 h1 {
     ${renderTypographyStyles(theme.typography.DS_h1)};
     margin: ${theme.DS_spacing(['xlx'])} 0 ${theme.DS_spacing(['md'])} 0;

    ${theme.breakpoints.up('md')} {
       margin: ${theme.DS_spacing(['xxl'])} 0 ${theme.DS_spacing(['lg'])} 0;
    }  
   }
   h2 {
    ${renderTypographyStyles(theme.typography.DS_h2)};
    margin: ${theme.DS_spacing(['xlx'])} 0 ${theme.DS_spacing(['xs'])} 0;
    ${theme.breakpoints.up('md')} {
       margin: ${theme.DS_spacing(['xlx'])} 0 ${theme.DS_spacing(['sm'])} 0;
    }
   }
   h3 {
    ${renderTypographyStyles(theme.typography.DS_h3)};
    margin: ${theme.DS_spacing(['lgx'])} 0 ${theme.DS_spacing(['xxs'])} 0;
    ${theme.breakpoints.up('md')} {
       margin: ${theme.DS_spacing(['xl'])} 0 ${theme.DS_spacing(['xs'])} 0;
    } 
   }
   h4, h5, h6 {
    ${renderTypographyStyles(theme.typography.DS_copyBigBold)}; 
     margin: ${theme.DS_spacing(['lg'])} 0 ${theme.DS_spacing(['xxxs'])} 0;
    ${theme.breakpoints.up('md')} {
       margin: ${theme.DS_spacing(['lgx'])} 0 ${theme.DS_spacing(['xxs'])} 0;
    } 
   }
   
   ul {
      list-style-type: disc; 
   }
   
   ol {
   list-style:decimal;
   }

   p, li{
    ${renderTypographyStyles(theme.typography.DS_copyMediumRegular)};
   }
   
   li {
    margin: ${theme.DS_spacing(['xs'])} 0;
    margin-left: ${theme.DS_spacing(['xxxs'])};
   }
   :is(h1, h2, h3, h4, h5, h6) + :is(h1, h2, h3, h4, h5, h6) {
      margin-top: 0;
   }
   
   p + p {
        margin: 12px 0;
      }
    p + div img {
        margin-top: ${theme.DS_spacing(['md'])};
      }
    p + ul, + ol {
      margin-top: ${theme.DS_spacing(['md'])};
      }
      
     p + span:has(a) {
        margin-top: ${theme.DS_spacing(['md'])};
      }

    ${theme.breakpoints.up('md')} {
     p + p {
      margin: 14px 0;
      }
      p + div img{
      margin-top: ${theme.DS_spacing(['lg'])};
      }
     p  + ul, + ol,{
      margin-top: ${theme.DS_spacing(['md'])};
      }
      p + span:has(a) {
        margin-top: ${theme.DS_spacing(['md'])};
      }
    }
   
`;

export const pinkBulletStyles = ({ theme }) => `
    li {
       list-style: none;
         p:before {
            content: "\\2022";  
            color:  ${theme.DS_palette.cards.attention};
            font-weight: bold;
            display: inline-block;
            width: ${theme.DS_spacing(['sm'])};
            position: absolute;   
            left: -${theme.DS_spacing(['xs'])};
            transform: translateY( -50%);
            top: 50%;
          }
       }
`;

export const styledAsteriskNote = ({ theme }) => `
     p{
     ${renderTypographyStyles(theme.typography.DS_copySmallRegular)};
     color: ${theme.DS_palette.text.secondary};
     > span > a{
       color: ${theme.DS_palette.text.secondary} !important;
       text-decoration-color: ${theme.DS_palette.text.secondary};
     }
    }
  
     p: last-of-type {
      margin-bottom: 0;
     }
`;

export const StyledBannerDiscount = ({ theme }) => `
     position: relative;
     padding: ${theme.DS_spacing(['xxxs'])} ${theme.DS_spacing(['xs'])};
     border: 0.8px solid  ${theme.DS_palette.tag.text};
     border-radius: ${theme.DS_spacing(['xxsx'])};
     margin-bottom: ${theme.DS_spacing(['xxsx'])};
     background: rgb(255,255,255);
     background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,244,249,1) 13%, rgba(234,121,166,0.08729429271708689) 50%, rgba(255,255,255,1) 85%, rgba(255,244,249,1) 100%);
     p {
      color: ${theme.DS_palette.text.primary};
      padding-left: ${theme.DS_spacing(['md'])};
      line-height: 14px;
     }
     svg {
      path {
       stroke: ${theme.DS_palette.tag.text};
      }
 
     fill: none;
     font-size: ${theme.DS_spacing(['md'])};
     position: absolute;
     top: calc(50% - 3px);
     left: 8px;
     transform: translateY(-50%);
   }
   
   ${theme.breakpoints.up('md')} {
     padding: ${theme.DS_spacing(['xxs'])} ${theme.DS_spacing(['xs'])};
   }
`;

export const StyledCardFootnote = ({ theme }) => `
   color: ${theme.DS_palette.text.secondary};
   padding-top: ${theme.DS_spacing(['xxs'])};
;`;

export const StyledSpecialDisclaimer = ({ theme }) => `
        p {
       color: ${theme.DS_palette.text.secondary};
        text-align: left;
        font-size:  ${theme.typography.DS_labelSmallRegular.fontSize};
        line-height: 18px;
        > i {
         font-size:  ${theme.typography.DS_copyMediumRegular.fontSize};
         font-style: normal;
        }
      }
;`;
